import React from 'react';
import DistritbutionTracking from 'components/Tvendo/Distribution/Operations/TrackingDist/List';

export default function () {
  return <DistritbutionTracking />;
}
